export const paymentMethods = [
  { id: 1, value: "Cash" },
  { id: 2, value: "Card" },
  { id: 3, value: "UPI" },
];

export const TAXES = {
  CGST: "cgst",
  SGST: "sgst",
};

export const INVOICE_TAXES = ["cgst", "sgst"];

export const CLEANING_STATUSES = {
  CLEAN: "clean",
  DIRTY: "dirty",
  ASSIGNED: "assigned",
};

export const RESERVATION_STATUSES = {
  CONFIRMED: "confirmed",
  TENTATIVE: "tentative",
  CHECK_IN: "check_in",
  CANCELLED: "cancelled",
  SELF_CHECK_IN: "self_check_in",
};

export const DISCOUNT_TYPE_SYMBOLS = {
  FLAT: "₹",
  PERCENTAGE: "%",
};

export const OCCUPANCY_STATUSES = {
  CHECK_IN: "check_in",
  CHECK_OUT: "check_out",
  ROOM_SHIFT: "room_shift",
  RESERVED: "reserved",
};

export const STAY_TYPES = {
  DAY: "day",
  HOUR: "hour",
  NOON: "noon",
  STANDARD: "standard",
};

export const ID_TYPES = {
  AADHAAR: "aadhaar",
  PASSPORT: "Passport",
};

export const BILLING_TYPE = {
  CUSTOMER: "customer",
  COMPANY: "company",
  N_BILL: "n_bill",
};

export const BILLING_MODES = {
  GROUP: "group",
  SEPARATE: "separate",
};

export const BILLING_CATEGORIES = {
  STAY: "stay",
  CHARGES_POSTING: "charges_posting",
  PAID_OUT: "paid_out",
  GUEST_DISBURSEMENT: "guest_disbursement",
};

export const USER_ROLES = {
  ADMIN: "admin",
  RECEPTIONIST: "receptionist",
  HOUSEKEEPING_MANAGER: "housekeeping_manager",
  GUEST: "guest",
  APP_ADMIN:"app_admin"
};

export const ENQUIRY_SOURCES_CODE = {
  ONLINE: "online",
  OFFLINE: "offline",
  WALKIN: "walk_in",
  OTA: "ota",
};

export const TAX_PERCENT = 12;

export const EVENTS = {
  NEW_RESERVATION: "new_reservation",
  CANCELLATION: "cancellation",
  NEW_CHECKIN: "new_check_in",
  EDIT_CHECKIN: "edit_check_in",
  DELETE_CHECKIN: "delete_check_in",
  CHECKOUT: "check_out",
  EDIT_CHECKOUT: "edit_check_out",
  DELETE_CHECKOUT: "delete_check_out",
  ADD_PAYMENT: "add_payment",
  EDIT_RENT: "edit_rent",
  APPROVAL_REQUESTED: "approval_requested",
  APPROVAL_APPROVED: "approval_approved",
  APPROVAL_REJECTED: "approval_rejected",
  APPROVAL_FAILED: "approval_failed",
};

export const OCCUPANCY_PHASES = {
  ACTIVE: "active",
  PREVIOUS: "previous",
};

export const OCCUPANCY_CHARGE = {
  PAID_OUT: "PAID_OUT",
  GUEST_DISBURSEMENT: "GUEST_DISBURSEMENT",
};

export const ARRIVAL_TIMER_CODE = {
  GREAT: "great",
  GOOD: "good",
  COMPLETED: "completed",
};

export const PRIORITY_OPTIONS = [
  { value: "High", label: "High" },
  { value: "Medium", label: "Medium" },
  { value: "Low", label: "Low" },
];

export const TASK_REPORT_ROWS_PER_PAGE = 10;

export const FILTER_STATUS_OPTIONS = ["All", "Todo", "InProgress", "Done"];
export const FILTER_PRIORITY_OPTIONS = ["All", "High", "Medium", "Low"];

export const TASK_LOAD_LIMIT = 20;

export const TASK_VIEW_CONFIG = {
  PARAM: "view",
  DOWNLOAD_MODE: "download",
};

//employee creation constants
export const SUPPORTED_IMAGE_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
export const todayMinus18Years = new Date();
todayMinus18Years.setFullYear(todayMinus18Years.getFullYear() - 18);

// Shift & Attendance Constants
export const VIEW_MODES = {
  WEEK: 'Week',
  MONTH: 'Month',
};

export const FILTER_OPTIONS = {
  ALL: 'All',
};

export const ATTENDANCE_STATUS = {
  ONGOING: 'ongoing',
  COMPLETED: 'completed',
  LEAVE: 'leave',
};

export const DATE_FORMATS = {
  API_DATE: 'yyyy-MM-dd',
  DISPLAY_DATE: 'dd MMM',
  DISPLAY_DATE_FULL: 'dd MMM yyyy',
  DISPLAY_MONTH: 'MMMM yyyy',
  TIME_AMPM: 'h:mm A',
  DAY_NAME: 'EEE',
  DAY: 'dd',
  MONTH: 'MMMM',
  YEAR: 'yyyy',
};

export const SHIFT_TYPES = {
  ATTENDANCE: 'Attendance',
};


export const MEAL_PLANS = [
  { value: "EP", label: "EP" },
  { value: "CP", label: "CP" },
  { value: "MAP", label: "MAP" },
  { value: "AP", label: "AP" },
];

export const PRICING_LOGICS = [
  { value: "Per Room", label: "Per Room" },
  { value: "Per Person", label: "Per Person" },
];

export const EXTRA_ADULT_OPTIONS = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

export const CHILD_POLICY_OPTIONS = [
  { value: "Chargeable", label: "Chargeable" },
  { value: "Free", label: "Free" },
];

export const CHANNEL_VISIBILITY_OPTIONS = [
  { value: "OTA", label: "OTA" },
  { value: "Direct", label: "Direct" },
  { value: "Both", label: "Both" },
];

export const COUPON_CONSTANTS = {
  DISCOUNT_TYPES: {
    PERCENTAGE: "Percentage",
    FIXED: "Fixed Amount",
  },
  DISCOUNT_SCOPES: {
    ROOM_RENT: "Room Rent Only",
    INVOICE_TOTAL: "Invoice Total",
  },
  COUPON_TYPES: {
    RECURRING_GUEST: "Recurring Guest",
    REFERRAL: "Referral",
    CUSTOM: "Custom",
  },
};
